<template>
  <SectionTab
    :title="$t('reporting.industry.material')"
    :description="$t('reporting.industry.materialOverview')"
    :date="date"
  >
    <template v-slot:section>
      <div class="materials" v-if="dataAvailable">
        <ListItem
          class="card card--sub"
          v-for="areaWithFractions in areasWithFractions"
          :key="areaWithFractions.area_name"
        >
          <template v-slot:row-cols>
            <div class="main-row__col card--sub__title">
              {{ areaWithFractions.area_name }}
            </div>
          </template>
          <template v-slot:toggle-area>
            <div class="fraction-data-container">
              <FractionDataTable class="fraction-table" :fractions="areaWithFractions.fractions" />
              <FractionDataGraph class="fraction-graph" :fractions="areaWithFractions.fractions" />
            </div>
          </template>
        </ListItem>
      </div>
      <p v-else class="alert alert-info">
        {{ $t('reporting.industry.noData') }}
      </p>
    </template>
  </SectionTab>
</template>

<script>
import ListItem from '@/components/ListItems'
import FractionDataGraph from '@/components/Reporting/Industry/Materials/FractionDataGraph'
import FractionDataTable from '@/components/Reporting/Industry/Materials/FractionDataTable'
import SectionTab from '@/components/Reporting/Industry/SectionTab'
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'Materials',
  components: { FractionDataGraph, FractionDataTable, ListItem, SectionTab },
  props: {
    areasWithFractions: {
      type: Array,
      required: true,
    },
    date: { type: String, default: '' },
  },
  mixins: [stringUtils],
  computed: {
    dataAvailable() {
      return this.areasWithFractions.length
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/views/reporting/reporting-industry.scss';

.card {
  &.card--sub {
    margin-left: 0.5rem;
    margin-top: 0.5rem;
  }

  &--sub {
    &__title {
      font-weight: 600;
      font-size: 1.125rem;
    }
  }
}

.fraction-data-container {
  display: flex;
  justify-content: space-around;
  column-gap: 10px;
  margin: 0 20px;
}

.fraction-table {
  flex: 1 1 60%;
}

.fraction-graph {
  min-height: 300px;
  flex: 1 0 40%;
  background-color: rgba(196, 196, 196, 0.19);
  border-radius: 10px;
  margin-bottom: 20px;
}
</style>
